import React, { Fragment, useState } from 'react';
import { Button, Card, Col, Form, Icon, Input, message, Modal, Result, Row, Select, Tooltip } from 'antd';
import * as CommonService from '../../../../services/CommonService';
import { CUSTOMER_ENDPOINT } from '../../../../services/endpoint';
import { currencyVND, formatCurrency } from '../../../../utils';
import SelectInfinitePro from '../../../../components/common/select-infinite-pro';
import CustomerCreate from '../../../customer/create';
import { SOURCE_ORDER } from '../../../../utils/const';

const { Option } = Select;

export default (props) => {
	const { getFieldDecorator } = props.form;
	const { customer, setCustomer, userList, branchList } = props;
	const [isModalOpen, setIsModalOpen] = useState(false);

	const [value, setValue] = useState(null);

	const handleSelect = async (value) => {
		if (value) {
			setValue(value);
			if (value.value === customer?.id) {
				message.error('Bạn đang chọn khách hàng này');
				return;
			}
			window.setLoading(true);
			const response = await CommonService.findById(CUSTOMER_ENDPOINT, value.value);
			setCustomer(response.data || null);
			window.setLoading(false);
		} else {
			setValue(null);
			setCustomer(null);
		}
		return false;
	};

	const InfoRow = ({ label, value }) => (
		<Row style={{ marginBottom: 8 }}>
			<Col span={6}>{label}</Col>
			<Col span={14}>: {value || '---'}</Col>
		</Row>
	);

	const renderAddress = () => {
		// if (!customer) return '---';
		return customer?.addressText || '---';
		// return [customer.ward, customer.district, customer.province].filter(Boolean).join(' - ');
	};

	const indicator = () => {
		return <Tooltip title={'Thêm mới khách hàng'}>
			<Button
				type={'link'}
				style={{ padding: 0 }}
				onClick={(e) => {
					setIsModalOpen(true);
				}}
			>
				➕
			</Button>
		</Tooltip>;
	};

	return (
		<Fragment>
			<Row gutter={12}>
				<Col lg={16}>
					<Card title={<Fragment><Icon type="user" /> Thông tin khách hàng</Fragment>}>
						<Row gutter={12}>
							<Col>
								<Form.Item label={'Chọn khách hàng'} required>
									<SelectInfinitePro endpoint={CUSTOMER_ENDPOINT}
																		 handleSelect={handleSelect}
																		 placeholder={'Tìm theo tên, mã...'}
																		 indicator={indicator}
																		 value={value}
									/>
								</Form.Item>
								{customer ? (
									<Row className={'mt-20'}>
										<Col span={12}>
											<InfoRow label="Tên khách hàng"
															 value={<Button type={'link'} style={{ height: '21px', padding: 0 }}
																							onClick={() => window.open('/customer/' + customer.id)}>{customer.name}</Button>} />
											<InfoRow label="Mã khách hàng" value={customer.customerCode} />
											<InfoRow label="Số điện thoại" value={customer.phoneNumber} />
											{/*<InfoRow label="Số điện thoại" value={customer.phoneNumber} />*/}
											{/*<InfoRow label="Email" value={customer.email} />*/}
											<InfoRow label="Địa chỉ giao hàng" value={renderAddress()} />
										</Col>
										<Col span={12}>
											<InfoRow
												label="Nợ hiện tại"
												value={
													<span style={{ color: 'red' }}>
														{currencyVND(customer.totalDebt)}
													</span>
												}
											/>
											<InfoRow
												label="Tổng chi tiêu"
												value={
													<i>
														{formatCurrency(customer.totalInvoice)}
													</i>
												}
											/>
											<InfoRow
												label="Tổng đơn hàng"
												value={
													<i>
														{formatCurrency(customer.totalOrder)}
													</i>
												}
											/>
										</Col>
									</Row>
								) : (
									<Result
										style={{ height: '130px', padding: 0 }}
										icon={<Icon type="user" />}
										subTitle="Chưa có thông tin khách hàng"
									/>
								)}
							</Col>
						</Row>
					</Card>
				</Col>
				<Col lg={8}>
					<Card title={'Thông tin bổ sung'}>
						<Form.Item label={'Bán tại'}>
							{getFieldDecorator('branchId', {
								initialValue: branchList?.[0]?.id
							})(
								<Select
									placeholder={'Chọn nơi bán'}
								>
									{branchList.map(el => <Option value={el.id}>{el.name}</Option>)}
								</Select>
							)}
						</Form.Item>
						<Form.Item label={'Người bán'} required>
							{getFieldDecorator('userId', {
								initialValue: userList.find(el => el.username === 'dinhhien')?.id || '',
								rules: [{ required: true, message: 'Vui lòng chọn người bán' }]
							})(
								<Select
									allowClear
									placeholder={'Chọn người bán'}
								>
									{userList.map(el => <Option value={el.id}>
										{el?.fullName || el.username}
									</Option>)}
								</Select>
							)}
						</Form.Item>
						<Form.Item label={'Nguồn hàng'}>
							{getFieldDecorator('source', {
								initialValue: 'WEBSITE'
							})(
								<Select
									placeholder={'Chọn nguồn hàng'}
								>
									{SOURCE_ORDER.map(el => <Option key={el.value}>{el.name}</Option>)}
								</Select>
							)}
						</Form.Item>
						<Form.Item label={'Đường dẫn mua hàng'}>
							{getFieldDecorator('pathOrder')(
								<Input
									placeholder={'Nhập đường dẫn mua hàng'}
								/>
							)}
						</Form.Item>
						<Form.Item label={'Địa chỉ nhận hóa đơn'}>
							{getFieldDecorator('billingAddress')(
								<Input
									placeholder={'Nhập địa chỉ nhận hóa đơn'}
								/>
							)}
						</Form.Item>
					</Card>
				</Col>
			</Row>
			<Modal visible={isModalOpen} title={'Thêm mới khách hàng'} footer={false} centered width={'large'}
						 style={{ height: '80vh', overflow: 'scroll' }} closable={false}>
				<CustomerCreate showAdditional={false} callback={async (data, form) => {
					setIsModalOpen(false);
					const item = data?.data;
					await handleSelect({ value: item.id });
					setValue({
						label: `${item.name} - ${item?.phoneNumber || 'SĐT chưa xác định'}`,
						value: item.id,
						data: item
					})
					form.resetFields();
				}} onExit={(form) => {
					form.resetFields();
					setIsModalOpen(false);
				}} />
			</Modal>
		</Fragment>
	);
}
;
